import { useLocalStorage } from "@mantine/hooks"
import { FileVariantType } from "db/enums"
import { FileWithVariants } from "utils/files/types"
import { useFileVariantPathContext } from "utils/files/useFilePathContext"

export default function useVideoVariant(file: FileWithVariants) {
  const [selectedQuality, setQuality] = useLocalStorage<FileVariantType>({
    key: `video-quality`,
    defaultValue: "MEDIUM_720P",
  })

  const getFileVariantUrl = useFileVariantPathContext()
  const url = getFileVariantUrl(file, selectedQuality, false)
  if (!url) {
    throw new Error(
      "Variant not found: Video variant bestaat niet, wordt waarschijnlijk nog verwerkt. Probeer het later opnieuw."
    )
  }
  return {
    setQuality,
    selectedQuality,
    url,
  }
}
